import { DataType } from '@inpart-io/padme-iap';
import { computed, type ComputedRef } from 'vue';
import { useRoute } from 'vue-router';

import { ROUTE_DATA } from '@/constants/routes.constants';

import { TOTAL_COUNT_KEY } from './useCountHelper';

export function useKeyHelper(): {
    searchKey: ComputedRef<string>;
    countKey: ComputedRef<string>;
} {
    const route = useRoute();

    const routeId = computed(() => {
        return route.params.id as string;
    });

    const searchKey = computed(() => {
        if (route.query.selectedAlliance) {
            return `alliance-${route.query.selectedAlliance as string}`;
        }
        switch (route.name) {
            case ROUTE_DATA.LEAD_OVERVIEW_PAGE.name:
                return route.query.selectedLead ? `lead-${route.query.selectedLead as string}` : `lead-${routeId.value}`;
            case ROUTE_DATA.COMPANY_OVERVIEW_PAGE.name:
                return `company-${routeId.value}`;
            case ROUTE_DATA.CONTACT_OVERVIEW_PAGE.name:
                return `contact-${routeId.value}`;
            case ROUTE_DATA.CONFERENCE_OVERVIEW_PAGE.name:
                return `conference-${routeId.value}`;
            case ROUTE_DATA.AGREEMENT_OVERVIEW_PAGE.name:
                return route.query.selectedAgreement ? `agreement-${route.query.selectedAgreement as string}` : `agreement-${routeId.value}`;
            case ROUTE_DATA.ALLIANCE_OVERVIEW_PAGE.name:
                return `alliance-${routeId.value}`;
            default:
                return `hub`;
        }
    });

    const countKey = computed(() => {
        if (route.query.selectedAlliance) {
            return `${DataType.AllianceDetail}-${TOTAL_COUNT_KEY}`;
        }
        switch (route.name) {
            case ROUTE_DATA.LEAD_OVERVIEW_PAGE.name:
                return `${DataType.Lead}-${TOTAL_COUNT_KEY}`;
            case ROUTE_DATA.COMPANY_OVERVIEW_PAGE.name:
                return `${DataType.PrivateCompany}-${TOTAL_COUNT_KEY}`;
            case ROUTE_DATA.CONTACT_OVERVIEW_PAGE.name:
                return `${DataType.PrivateContact}-${TOTAL_COUNT_KEY}`;
            case ROUTE_DATA.CONFERENCE_OVERVIEW_PAGE.name:
                return `${DataType.Conference}-${TOTAL_COUNT_KEY}`;
            case ROUTE_DATA.AGREEMENT_OVERVIEW_PAGE.name:
                return `${DataType.AgreementDetail}-${TOTAL_COUNT_KEY}`;
            case ROUTE_DATA.ALLIANCE_OVERVIEW_PAGE.name:
                return `${DataType.AllianceDetail}-${TOTAL_COUNT_KEY}`;
            default:
                return TOTAL_COUNT_KEY;
        }
    });

    return { searchKey, countKey };
}
